import { FC } from "react";
import { Routes, Route, Navigate, useLocation } from "react-router";
import { useModulePathResolver, ModuleErrorBoundary } from "capitalrx-shell";
import PageTitleWrapper from "../../layouts/Main/PageTitleWrapper";
import { appRoutes } from "../../routes/routes";

/**
 * The legacy content routes component.
 * @deprecated This component will be removed when everything is a module.
 */
export const LegacyContentRoutes: FC = () => {
  const resolvePath = useModulePathResolver();
  const path404 = resolvePath("/404");
  const location = useLocation();

  return (
    <Routes>
      {appRoutes.map(({ path, Component, pageTitle, redirectTo, exact }) => {

        if (!Component) return null;

        if (exact && location.pathname !== path) return null;

        let element = (
          <PageTitleWrapper pageTitle={pageTitle}>
            <ModuleErrorBoundary>
              <Component pageTitle={pageTitle} />
            </ModuleErrorBoundary>
          </PageTitleWrapper>
        );

        if (redirectTo) {
          const newPath = location.pathname.replace(path, redirectTo);
          element = <Navigate to={newPath} replace />;
        }

        return (
          <Route
            key={path}
            path={path}
            element={element}
          />
        );
      })}
      <Route path="/*" element={<Navigate to={path404} />} />
    </Routes>
  );
};
